const SORT_TABLE_DEFAULT = {

  data () {
    return {
      sortByName: '',
      sortBy: '',
    };
  },

  methods: {

    /**
         * Method for sorting columns
         *
         * @param {String} nameSort
         */
    sortingColumns (nameSort) {
      this.sortByName = nameSort;

      if (this.sortBy === '') {
        this.sortBy = 'asc';
      } else if (this.sortBy === 'asc') {
        this.sortBy = 'desc';
      } else if (this.sortBy === 'desc') {
        this.sortBy = 'asc';
      }

      if (this.filterParams.url.indexOf('sorted_by') != -1) {
        this.filterParams.url = this.filterParams.url.replace(/&sorted_by=([a-zA-Z_]*)/g, `&sorted_by=${this.sortByName}_${this.sortBy}`);
      } else {
        this.filterParams.url = this.filterParams.url + `&sorted_by=${this.sortByName}_${this.sortBy}`;
      }

      this.sortingTable();
    },

  },

};

export default SORT_TABLE_DEFAULT;
